import { API } from "@thenounproject/lingo-core";
import { createAsyncAction } from "@actions/actionCreators";

type Args = {
  spaceId: number;
  name: string;
  notes?: string;
  displayOrder?: number | "append";
};

const [useCreateMarket, createMarket] = createAsyncAction(
  "markets/create",
  async ({ spaceId, name, notes, displayOrder }: Args) => {
    const res = await API.call<{ market: string }>({
      endpoint: `spaces/${spaceId}/markets`,
      method: "POST",
      data: {
        name,
        notes,
        display_order: displayOrder,
      },
    });
    return { ...res, result: res.result.market };
  }
);

export default useCreateMarket;
export { createMarket };
